import { JSX } from "react";

interface AccuracyEvidenceRowProps {
    value: string;
    status: string;
    reference: string;
    rowDepth: string;
    keyName: string;
}

export default function AccuracyEvidenceRow(props: AccuracyEvidenceRowProps): JSX.Element {
    return (
        <div key={props.keyName}>
            <li className="list-group-item bordered" data-toggle="collapse">
                <div className={`col-4 evidence-depth-${props.rowDepth}`}>
                    {props.value}
                </div>
                < div className="col-4" >
                    {props.status}
                </div>
                <div className="col-4">
                    {props.reference}
                </div>
            </li>
        </div>
    );
}